import { MonthType } from './MonthType';

export const MonthTypeOptions = [
    {
        id: '',
        name: '',
        shortName: '',
        sortOrder: 0,
    },
    {
        id: MonthType.January,
        name: 'January',
        shortName: 'Jan.',
        sortOrder: 1,
    },
    {
        id: MonthType.February,
        name: 'February',
        shortName: 'Feb.',
        sortOrder: 2,
    },
    {
        id: MonthType.March,
        name: 'March',
        shortName: 'Mar.',
        sortOrder: 3,
    },
    {
        id: MonthType.April,
        name: 'April',
        shortName: 'Apr.',
        sortOrder: 4,
    },
    {
        id: MonthType.May,
        name: 'May',
        shortName: 'May.',
        sortOrder: 5,
    },
    {
        id: MonthType.June,
        name: 'June',
        shortName: 'Jun.',
        sortOrder: 6,
    },
    {
        id: MonthType.July,
        name: 'July',
        shortName: 'Jul.',
        sortOrder: 7,
    },
    {
        id: MonthType.August,
        name: 'August',
        shortName: 'Aug.',
        sortOrder: 8,
    },
    {
        id: MonthType.September,
        name: 'September',
        shortName: 'Sep.',
        sortOrder: 9,
    },
    {
        id: MonthType.October,
        name: 'October',
        shortName: 'Oct.',
        sortOrder: 10,
    },
    {
        id: MonthType.November,
        name: 'November',
        shortName: 'Nov.',
        sortOrder: 11,
    },
    {
        id: MonthType.December,
        name: 'December',
        shortName: 'Dec.',
        sortOrder: 12,
    },
];
